import instanceSettingsApi from './instanceSettingsApi';

// Returns the per-tenant app enablement map, e.g. { candispatch: true, ... }.
// Apps with no `enabled` row are absent from the map; callers treat absence
// as disabled (fail-closed).
const getEnabledApps = async (): Promise<Record<string, boolean>> => {
  try {
    const { data } = await instanceSettingsApi.get('/enabled-apps');
    return data?.data ?? {};
  } catch (error) {
    console.error('[getEnabledApps] Failed:', error);
    throw error;
  }
};

export default getEnabledApps;
